import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";

export default function reportingSyncUpdatedTimeReducer(
  state: String = initialState.reportingSyncUpdatedTime,
  action: AnyAction
): String {
  switch (action.type) {
    case internalActionKeys.GET_REPORTING_SYNC_UPDATED_TIME:
      return action.payload;
    default:
      return state;
  }
}
